export default "__VITE_ASSET__DLcfLj0Q__"